import { render, staticRenderFns } from "./ReleaseComment.vue?vue&type=template&id=38e28b5d"
import script from "./ReleaseComment.vue?vue&type=script&lang=js"
export * from "./ReleaseComment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports